// import { Pipe, PipeTransform } from '@angular/core';

// @Pipe({
//   name: 'saleName'
// })
// export class SaleNamePipe implements PipeTransform {

//   transform(orderId: string | undefined, shop: string | undefined): string {
//     if (!orderId || !shop) return '---';

//     switch (shop.toLowerCase()) {
//       case 'businesssales':
//         return `B${orderId}`;
//       case 'shopifysale':
//         return `D${orderId}`;
//       case 'flowerssales':
//         return `F${orderId}`;
//       case 'cakesales':
//         return `C${orderId}`;
//       default:
//         return orderId;
//     }
//   }

// }

import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'saleName'
})
export class SaleNamePipe implements PipeTransform {

  transform(orderId: string | undefined, shop: string | undefined, fallback?: string): string {
    if (!orderId) return fallback || '---';
    if (!shop) return fallback || orderId;

    switch (shop.toLowerCase()) {
      case 'businesssales':
        return `B${orderId}`;
      case 'shopifysale':
        return `D${orderId}`;
      case 'flowerssales':
        return `F${orderId}`;
      case 'cakesales':
        return `C${orderId}`;
      case 'deluxyexperiencesales':
        return `DE${orderId}`;
      case 'deluxydotcomsales':
        return `DC${orderId}`;
      default:
        return orderId;
    }
  }

}
